import { Eyebrow, Reveal } from "../components/Shared";
import { IMAGES, INSPECTION_STAGES, QUALITY_HIGHLIGHTS } from "../data/site";

const InspectionStrip = () => (
  <Reveal delay={0.2}>
    <div className="card relative mt-8 overflow-hidden px-6 py-10 sm:px-10" data-testid="inspection-strip">
      <p className="label-caps relative text-[10px]">Print Sheet — Inspection Sequence</p>
      <div className="relative mt-8">
        <div className="absolute left-0 right-0 top-1/2 h-px -translate-y-1/2 bg-line" />
        <div className="absolute left-0 right-8 top-1/2 h-px -translate-y-1/2">
          <span className="absolute top-1/2 h-1.5 w-8 -translate-y-1/2 animate-scan-x rounded-full bg-gradient-to-r from-transparent via-brand2 to-brand2" />
        </div>
        <div className="relative flex flex-wrap justify-between gap-y-8">
          {INSPECTION_STAGES.map((stage, i) => (
            <div key={stage} className="flex w-1/2 flex-col items-center gap-3 sm:w-auto" data-testid={`inspection-stage-${i + 1}`}>
              <span className="flex h-9 w-9 items-center justify-center rounded-lg border border-line bg-white text-[11px] font-semibold text-brand">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="text-center text-[10px] font-semibold uppercase tracking-[0.14em] text-slate">{stage}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </Reveal>
);

const QualitySection = () => (
  <section className="relative bg-white py-24 sm:py-32" data-testid="quality-section">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="grid gap-16 lg:grid-cols-2">
        <div>
          <Reveal>
            <Eyebrow>04 — Quality &amp; Philosophy</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display text-2xl font-bold tracking-tight text-navy sm:text-3xl lg:text-4xl">
              Excellence Through Consistency.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-base leading-relaxed text-slate sm:text-lg">
              From design to dispatch, every stage of production reflects our dedication to detail, precision and
              perfection.
            </p>
          </Reveal>
          <div className="mt-10 border-t border-line">
            {QUALITY_HIGHLIGHTS.map((h, i) => (
              <Reveal key={h.num} delay={i * 0.06}>
                <div
                  className="group -mx-4 flex items-start gap-6 rounded-xl border-b border-line px-4 py-5 transition-colors duration-300 hover:bg-canvas"
                  data-testid={`quality-highlight-${h.num}`}
                >
                  <span className="mt-0.5 text-xs font-semibold tracking-[0.16em] text-brand2">{h.num}</span>
                  <div>
                    <h3 className="font-display text-base font-bold text-navy sm:text-lg">{h.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-slate">{h.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
        <div className="flex flex-col justify-center">
          <Reveal delay={0.15}>
            <div className="relative overflow-hidden rounded-2xl border border-line shadow-sm">
              <img
                src={IMAGES.inspection}
                alt="Quality inspection of printed sheets"
                className="h-72 w-full object-cover sm:h-96"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/80 via-navy/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-7">
                <p className="font-display text-xl font-bold leading-snug tracking-tight text-white sm:text-2xl">
                  Quality isn't checked only at the end.
                  <br />
                  <span className="text-white/80">It is built into every stage.</span>
                </p>
              </div>
            </div>
          </Reveal>
          <InspectionStrip />
        </div>
      </div>
    </div>
  </section>
);

export default QualitySection;
